module.exports = __webpack_public_path__ + "static/ogImage-b61badb6fd2d075cfd625534fc55f6e5.jpeg";